var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCovidVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.755,
    height: 16.861,
    viewBox: "0 0 14.755 16.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-organism-2188559",
    transform: "translate(-123.931 -23.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28025",
    "data-name": "Path 28025",
    d: "M138.5,28.086a.4.4,0,0,0-.43-.679l-1.106.7-5.255-3V23.732a.4.4,0,1,0-.8,0V25.1l-5.2,2.97L124.6,27.3a.4.4,0,1,0-.459.659l1.146.8v5.992l-1.17.741a.4.4,0,0,0,.43.679l1.152-.73,5.208,2.976V39.79a.4.4,0,0,0,.8,0V38.417l5.2-2.971,1.11.772h0a.4.4,0,1,0,.458-.659l-1.146-.8V28.827Zm-1.973,6.654-5.219,2.982L126.09,34.74V28.782l5.219-2.982,5.219,2.982Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28026",
    "data-name": "Path 28026",
    d: "M352.005,190.68a2.009,2.009,0,1,0-1.419-.588A2.007,2.007,0,0,0,352.005,190.68Zm0-3.212a1.206,1.206,0,1,1-.851.353A1.2,1.2,0,0,1,352.005,187.469Z",
    transform: "translate(-218.288 -157.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28027",
    "data-name": "Path 28027",
    d: "M211.608,256.67a1.608,1.608,0,1,0,1.135.471A1.605,1.605,0,0,0,211.608,256.67Zm0,2.409a.8.8,0,1,1,.568-.235.8.8,0,0,1-.568.235Z",
    transform: "translate(-83.109 -225.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidVirus);
export default __webpack_public_path__ + "static/media/covid-virus.e573f9e6a7de2025a771d5e4480f7334.svg";
export { ForwardRef as ReactComponent };